(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-ingles-clinico-usa"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initialiseNurseBridge(root){
    if(!root||root.dataset.nb7Ready==='true')return;
    root.dataset.nb7Ready='true';
    var reducedMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function observeMotion(section,tracks,prepare){
    if(!section||reducedMotion)return;
    function setRunning(running){
      if(running&&prepare)prepare();
      tracks.forEach(function(track){track.classList.toggle('is-running',running)});
    }
    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){setRunning(entry.isIntersecting)});
      },{rootMargin:'260px 0px',threshold:.01});
      observer.observe(section);
    }else{
      setRunning(true);
    }
  }

    var institutionSection=root.querySelector('.nb7-inst');
    var institutionTrack=root.querySelector('.nb7-inst-track');
    var institutionSource=root.querySelector('.nb7-inst-segment.nb7-inst-logos:not([data-nb7-inst-clone])');
    var institutionClone=root.querySelector('[data-nb7-inst-clone]');
    var institutionReady=false;
    function prepareInstitution(){
      if(institutionReady)return;
      institutionReady=true;
      if(institutionSource&&institutionClone)institutionClone.innerHTML=institutionSource.innerHTML;
    }
    observeMotion(institutionSection,institutionTrack?[institutionTrack]:[],prepareInstitution);

    var scenesSection=root.querySelector('.nb7-scenes');
    var scenesTracks=Array.prototype.slice.call(root.querySelectorAll('.nb7-scenes-track'));
    observeMotion(scenesSection,scenesTracks);

    // CTAs add the digital product through Shopify's native cart Ajax API.
    // Shopify/Meta Web Pixels track the real cart mutation: no manual fbq calls.
    var cartButtons=Array.prototype.slice.call(root.querySelectorAll('a.nb7-btn[href]'));
    var cartRoute=root.getAttribute('data-nb7-cart-url')||'/cart';
    var cartAddRoute=root.getAttribute('data-nb7-add-url')||'/cart/add.js';
    var variantId=Number(root.getAttribute('data-nb7-variant-id'));
    var cartRedirectBusy=false;
    function resetCartButtons(){
      cartRedirectBusy=false;
      cartButtons.forEach(function(button){
        var label=button.querySelector('span');
        button.classList.remove('is-redirecting');
        button.removeAttribute('aria-busy');
        button.removeAttribute('data-redirecting');
        if(label&&label.getAttribute('data-original-label'))label.textContent=label.getAttribute('data-original-label');
      });
    }
    cartButtons.forEach(function(button){
      var label=button.querySelector('span');
      if(label&&!label.getAttribute('data-original-label')){
        label.setAttribute('data-original-label',label.textContent.trim());
        label.setAttribute('aria-live','polite');
      }
      button.addEventListener('click',function(event){
        if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;
        if(cartRedirectBusy){event.preventDefault();return;}
        if(!variantId||!window.fetch)return; // Shopify cart permalink remains as fallback.
        event.preventDefault();
        cartRedirectBusy=true;
        button.setAttribute('data-redirecting','true');
        button.setAttribute('aria-busy','true');
        button.classList.add('is-redirecting');
        if(label)label.textContent='Redirigiendo al carrito…';

        // When the product is already in the cart, avoid charging for two copies
        // or sending another AddToCart event for a non-addition.
        fetch(cartRoute+'.js',{method:'GET',credentials:'same-origin',headers:{'Accept':'application/json'}})
          .then(function(response){if(!response.ok)throw new Error('cart_read_failed');return response.json()})
          .then(function(cart){
            var alreadyAdded=Array.isArray(cart.items)&&cart.items.some(function(item){return Number(item.variant_id)===variantId;});
            if(alreadyAdded)return;
            var data=new FormData();
            data.append('id',String(variantId));
            data.append('quantity','1');
            return fetch(cartAddRoute,{
              method:'POST',credentials:'same-origin',
              headers:{'Accept':'application/json'},body:data
            }).then(function(response){
              if(!response.ok)throw new Error('cart_add_failed');
              return response.json();
            });
          })
          .then(function(){
            // Allow Shopify's native Web Pixel listener to observe the successful add.
            window.setTimeout(function(){window.location.assign(cartRoute);},350);
          })
          .catch(function(error){
            console.error('NurseBridge: no se pudo abrir el carrito',error);
            resetCartButtons();
            if(label)label.textContent='Intentar de nuevo';
          });
      });
    });
    window.addEventListener('pageshow',resetCartButtons);

    if('IntersectionObserver' in window&&!reducedMotion){
      var revealTargets=root.querySelectorAll('.nb7-proof article,.nb7-head,.nb7-path,.nb7-whisper,.nb7-reframe,.nbx-head,.nbx-step,.nbx-live-example,.nbx-benefit,.nbx-extra,.nb7-shot,.nb7-compare,.nb7-person,.nb7-offer-copy,.nb7-price');
      revealTargets.forEach(function(element){element.classList.add('nb7-reveal')});
      var revealObserver=new IntersectionObserver(function(entries,observer){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('is-shown');
            observer.unobserve(entry.target);
          }
        });
      },{threshold:.08,rootMargin:'0px 0px -6% 0px'});
      revealTargets.forEach(function(element){revealObserver.observe(element)});
    }

    var viewerCount=root.querySelector('[data-atlas-viewer-count]');
    var viewerSection=root.querySelector('.nb7-offer');
    if(viewerCount&&viewerSection){
      var viewerNumbers=[7,9,4,13,17,5,3];
      var viewerTimer=0;
      function changeViewerCount(){
        var current=Number(viewerCount.textContent);
        var available=viewerNumbers.filter(function(number){return number!==current});
        viewerCount.textContent=available[Math.floor(Math.random()*available.length)];
      }
      function startViewerCount(){
        if(viewerTimer)return;
        changeViewerCount();
        viewerTimer=window.setInterval(changeViewerCount,60000);
      }
      function stopViewerCount(){
        if(viewerTimer){window.clearInterval(viewerTimer);viewerTimer=0}
      }
      if('IntersectionObserver' in window){
        var viewerObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){if(entry.isIntersecting)startViewerCount();else stopViewerCount()});
        },{rootMargin:'180px 0px',threshold:.01});
        viewerObserver.observe(viewerSection);
      }else{
        startViewerCount();
      }
    }

    var purchaseToast=root.querySelector('#ahl-demo-toast');
    var purchaseName=root.querySelector('#ahl-demo-toast-name');
    if(purchaseToast&&purchaseName&&purchaseToast.dataset.ready!=='true'){
      purchaseToast.dataset.ready='true';
      var purchaseNames=['Leo de New Jersey','Mariana de Florida','Diego de Texas','Valentina de California','Carlos de New York','Lucía de Pennsylvania','Martín de Illinois','Camila de Massachusetts','Alejandro de Georgia','Sofía de North Carolina','Javier de Ohio','Daniela de Washington','Mateo de Texas','Laura de New Jersey','Nicolás de California','Andrea de Florida','Miguel de New York','Paula de Pennsylvania','Fernando de Illinois','Elena de Massachusetts'];
      var purchaseStorageKey='ahl_demo_recent_names_v2';
      var purchaseNamesUsed=[];
      var purchaseQueue=[];
      var purchaseShowing=false;
      function readPurchaseHistory(){try{var saved=JSON.parse(window.localStorage.getItem(purchaseStorageKey));return Array.isArray(saved)?saved:[]}catch(error){return[]}}
      function savePurchaseHistory(history){try{window.localStorage.setItem(purchaseStorageKey,JSON.stringify(history))}catch(error){return}}
      function getPurchaseName(){
        var history=readPurchaseHistory();
        var blocked=history.concat(purchaseNamesUsed);
        var available=purchaseNames.filter(function(name){return blocked.indexOf(name)===-1});
        if(available.length===0){history=[];available=purchaseNames.filter(function(name){return purchaseNamesUsed.indexOf(name)===-1})}
        if(available.length===0)available=purchaseNames.slice();
        var selected=available[Math.floor(Math.random()*available.length)];
        purchaseNamesUsed.push(selected);
        savePurchaseHistory(history.concat(selected).slice(-12));
        return selected;
      }
      function showNextPurchase(){
        if(purchaseShowing||purchaseQueue.length===0)return;
        purchaseShowing=true;
        purchaseQueue.shift();
        purchaseName.textContent=getPurchaseName();
        purchaseToast.classList.add('ahl-demo-toast--visible');
        window.setTimeout(function(){
          purchaseToast.classList.remove('ahl-demo-toast--visible');
          window.setTimeout(function(){purchaseShowing=false;showNextPurchase()},350);
        },7800);
      }
      var purchaseTriggers=[root.querySelector('.nb7-transform'),root.querySelector('[data-atlas-price-window]')].filter(Boolean);
      if('IntersectionObserver' in window){
        var purchaseObserver=new IntersectionObserver(function(entries,observer){
          entries.forEach(function(entry){
            if(entry.isIntersecting&&entry.target.dataset.purchaseShown!=='true'){
              entry.target.dataset.purchaseShown='true';
              purchaseQueue.push(entry.target);
              observer.unobserve(entry.target);
              showNextPurchase();
            }
          });
        },{threshold:.18,rootMargin:'0px 0px -15% 0px'});
        purchaseTriggers.forEach(function(element){purchaseObserver.observe(element)});
      }
    }


  }

  function initialiseAllNurseBridge(){
    document.querySelectorAll('.nb7').forEach(initialiseNurseBridge);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialiseAllNurseBridge,{once:true});
  else initialiseAllNurseBridge();
  document.addEventListener('shopify:section:load',function(event){
    initialiseNurseBridge(event.target.querySelector('.nb7'));
  });
})();
(function(){
  function initialiseAtlasPriceWindow(module){
    if(!module||module.dataset.atlasReady==='true')return;
    module.dataset.atlasReady='true';

    var root=module.closest('.nb7');
    var dateElement=module.querySelector('[data-atlas-end-date]');
    var phaseElement=module.querySelector('[data-atlas-phase]');
    var progressElement=module.querySelector('[data-atlas-progress]');
    var startLabel=module.querySelector('[data-atlas-start-label]');
    var endLabel=module.querySelector('[data-atlas-end-label]');
    var insightElement=module.querySelector('[data-atlas-insight]');
    var activeInsight=insightElement?insightElement.textContent:'';
    var count=root.querySelector('[data-nb7-count]');
    var promo=root.querySelector('[data-nb7-promo]');
    var showCount=count&&count.classList.contains('is-active');
    var showPromo=promo&&promo.classList.contains('is-active');
    var fields=count?{
      d:count.querySelector('[data-days]'),h:count.querySelector('[data-hours]'),
      m:count.querySelector('[data-minutes]'),s:count.querySelector('[data-seconds]')
    }:null;
    var fullDate=new Intl.DateTimeFormat('es-US',{day:'numeric',month:'long',year:'numeric'});
    var shortDate=new Intl.DateTimeFormat('es-US',{day:'numeric',month:'short'});
    var start=0;
    var end=0;
    var endDate;
    var deadlineLabel='';
    var timer=0;

    function setText(node,value){if(node&&node.textContent!==value)node.textContent=value}
    function pad(number){return String(number).padStart(2,'0')}
    function calendarDay(date){return Date.UTC(date.getFullYear(),date.getMonth(),date.getDate())/86400000}

    function beginVisit(){
      var today=new Date();
      var startDate=new Date(today.getFullYear(),today.getMonth(),today.getDate());
      endDate=new Date(today.getFullYear(),today.getMonth(),today.getDate()+2,23,59,59,999);
      start=startDate.getTime();
      end=endDate.getTime();
      deadlineLabel=fullDate.format(endDate)+' a las 11:59 p.m. (tu hora local)';
      module.setAttribute('data-start',startDate.toISOString());
      module.setAttribute('data-end',endDate.toISOString());
      setText(dateElement,deadlineLabel);
      setText(startLabel,'Desde el '+shortDate.format(startDate));
      setText(endLabel,'Hasta el '+shortDate.format(endDate));
      root.querySelectorAll('[data-nb7-deadline-label]').forEach(function(label){
        setText(label,'Hasta el '+deadlineLabel);
      });
      if(count)count.setAttribute('data-end',endDate.toISOString());
      updateAtlasPriceWindow();
      module.hidden=false;
    }

    function updateAtlasPriceWindow(){
      var now=Date.now();
      var remaining=Math.max(end-now,0);
      var progress=Math.min(Math.max((now-start)/(end-start)*100,0),100);
      var position=remaining>0?85+progress*.02:100;
      var days=Math.max(calendarDay(endDate)-calendarDay(new Date(now)),0);
      var phase=remaining<=0?'Plazo finalizado':days===0?'Vence hoy':days===1?'Vence mañana':'Vence en '+days+' días';
      module.classList.toggle('is-ended',remaining<=0);
      module.style.setProperty('--nb7-progress',String(position/100));
      module.style.setProperty('--nb7-progress-position',position+'%');
      module.style.setProperty('--nb7-marker-label-shift',position>90?'-100%':'-50%');
      setText(insightElement,remaining>0?activeInsight:'El plazo mostrado ha finalizado. Consulta el precio al pagar.');
      setText(phaseElement,phase);
      if(progressElement){
        progressElement.setAttribute('aria-valuenow',String(Math.round(position)));
        progressElement.setAttribute('aria-valuetext',phase+'. Hasta el '+deadlineLabel);
      }
      if(count){
        count.classList.toggle('is-active',Boolean(showCount&&remaining>0));
        setText(fields.d,pad(Math.floor(remaining/86400000)));
        setText(fields.h,pad(Math.floor(remaining/3600000)%24));
        setText(fields.m,pad(Math.floor(remaining/60000)%60));
        setText(fields.s,pad(Math.floor(remaining/1000)%60));
      }
      if(promo)promo.classList.toggle('is-active',Boolean(showPromo&&remaining>0));
      if(remaining<=0)stopUpdates();
    }

    function startUpdates(){
      updateAtlasPriceWindow();
      if(!timer&&end>Date.now())timer=window.setInterval(updateAtlasPriceWindow,showCount?1000:30000);
    }
    function stopUpdates(){
      if(timer){window.clearInterval(timer);timer=0}
    }
    function handleVisibility(){
      if(document.hidden)stopUpdates();else startUpdates();
    }
    function handlePageShow(event){
      if(event.persisted){beginVisit();startUpdates()}
    }
    function handleUnload(event){
      if(!event.target.contains(module))return;
      stopUpdates();
      document.removeEventListener('visibilitychange',handleVisibility);
      document.removeEventListener('shopify:section:unload',handleUnload);
      window.removeEventListener('pageshow',handlePageShow);
    }

    beginVisit();
    handleVisibility();
    document.addEventListener('visibilitychange',handleVisibility);
    document.addEventListener('shopify:section:unload',handleUnload);
    window.addEventListener('pageshow',handlePageShow);
  }

  function initialiseAllAtlasPriceWindows(){
    document.querySelectorAll('[data-atlas-price-window]').forEach(initialiseAtlasPriceWindow);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialiseAllAtlasPriceWindows,{once:true});
  else initialiseAllAtlasPriceWindows();
  document.addEventListener('shopify:section:load',initialiseAllAtlasPriceWindows);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
